<h2 mat-dialog-title>Add Control Item - {{ categoryName }}</h2>
<mat-dialog-content>
  <form [formGroup]="controlItemForm">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()">Save</button>
</mat-dialog-actions>
